export default "__VITE_ASSET__a3e47916__"